export default __webpack_public_path__ + "static/soehne-web-kraftig-4016fc3e5496b07fad5f0532d19b7f7b.eot";